<template>
  <!-- 培训记录 -->
  <div class="trainingRecord">
    <van-nav-bar :title="$t('examRecord.ErTxt1')"
                 left-text
                 left-arrow
                 @click-left="onClickLeft"
                 @click-right="onClickRight"
                 :fixed="true" />
    <div class="fixedH"
         style="height: 1.22667rem;"></div>
    <van-search v-model="value"
                shape="round"
                :placeholder="$t('examRecord.ErTxt2')"
                @search="onSearch"
                style="margin-bottom:10px;" />
    <!-- 审核中 -->
    <div class="reviewed">
      <van-list v-model="loadingAlready"
                :finished="finishedAlready"
                :finished-text="$t('examRecord.ErTxt3')"
                @load="onLoad">
        <van-cell v-for="item in alreadyList"
                  :key="item"
                  @click="reviewedInfo(item)">
          <div class="list_no">
            {{$t('trainRecordsDetails.TrdTxt3')}}{{item.listno}}
          </div>
          <div class="list_va">
            <div class="up">
              <div class="papername">
                <div class="title">
                  <img src="@/assets/img/examRecord_1.png"
                       alt="" />
                  {{ item.papername }}
                </div>
                <div class="score">
                  {{ item.score }}
                  <span>{{$t('toEvaluated.evaluateTxt8')}}</span>
                </div>
              </div>
              <div class="others">
                <div class="label">{{$t('examRecord.ErTxt4')}}</div>
                <div class="val">{{ item.coursetype }}</div>
              </div>
              <div class="others">
                <div class="label">{{$t('examRecord.ErTxt5')}}</div>
                <div class="val">{{ item.totalscore }}</div>
              </div>
              <div class="others">
                <div class="label">{{'课程名称：'}}</div>
                <div class="val">{{ item.coursename }}</div>
              </div>
            </div>
            <div class="down">
              <div class="label">{{$t('examRecord.ErTxt6')}}</div>
              <div class="val">{{ item.et }}</div>
              <van-tag :type="item.teststyle =='补考'?'danger':'warning'">{{ item.teststyle }}</van-tag>
            </div>
          </div>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
import { getHisPostPaperList } from '@api/wxpx.js'
import { searchFunc } from '@/utils'
import { Toast } from 'vant'
export default {
  name: 'trainRecords',
  data () {
    return {
      userInfo,
      value: '',
      active: 0,
      isLoadingAwait: false,
      awaitList: [],
      loadingAwait: false,
      finishedAwait: false,
      isLoadingAlready: false,
      alreadyList: [],
      loadingAlready: false,
      finishedAlready: false,
      oldlist: [],
      form: {
        papername: ''
      }
    }
  },
  methods: {
    // 回退
    onClickLeft () {
      if (window.CloundEntid == '115')
      {
        window.location.href = 'http://hyclound.cn/hgvis_115_h5/pc2022_5.html'
      } else
      {
        this.$router.push('/home')
      }
    },
    onClickRight () { },
    onLoad () {
      getHisPostPaperList({
        empid: this.userInfo.empid
      }).then(res => {        
        this.alreadyList = res.data
        this.oldlist = this.alreadyList
        // 加载状态结束
        this.loadingAlready = false
        this.finishedAlready = true
      })
    },
    reviewedInfo (itm) {
      this.$router.push({
        path: '/checkOutAnswer',
        query: {
          mautoid: itm.mautoid,
          paperid: itm.paperid,
          teststyle: itm.teststyle,
          pmid: itm.pmid,
          returnPath: 'examRecord'
        }
      })
    },
    // 搜索
    onSearch () {
      var arr = searchFunc(this.value, this.form, this.oldlist)
      if (arr.length > 0)
      {
        this.alreadyList = arr
        this.value = ''
      } else
      {
        Toast(this.$t('examRecord.ErTxt7'))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.trainingRecord {
  height: 100vh;
  background: #eceaea;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    ::v-deep .van-nav-bar__right {
      .van-nav-bar__text {
        color: #fff;
        font-family: Source Han Sans CN;
      }
    }
  }
  .reviewed {
    /deep/.van-list {
      .van-cell {
        padding: 0 !important;
        margin-bottom: 28px;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);
        .van-cell__value {
          .list_no {
            padding: 0 20px;
            margin-bottom: 20px;
            font-size: 24px;
            color: #666666;
            line-height: 64px;
            word-break: break-all;
            background: linear-gradient(
              90deg,
              rgba(25, 137, 250, 0) 0%,
              rgba(25, 137, 250, 0.5) 0%,
              rgba(25, 137, 250, 0) 100%
            );
          }
          .list_va {
            padding: 0 20px;
          }
          .up {
            position: relative;
            font-family: Source Han Sans CN;
            border-bottom: 2px solid #ccc;
            font-size: 28px;
            color: #999;
            // padding-bottom: 22px;
            .papername {
              display: flex;
              align-items: center;
              justify-content: space-between;
              border-bottom: 2px solid #ccc;
              padding-bottom: 10px;
              .title {
                font-size: 32px;
                color: #333333;
                line-height: 54px;
                font-weight: bold;
              }
              .score {
                display: flex;
                align-items: baseline;
                font-size: 40px;
                font-family: DIN;
                font-weight: bold;
                span {
                  font-size: 28px;
                }
              }
            }
            .others {
              display: flex;
              padding: 8px 0;
              .label {
                width: 30%;
                font-size: 28px;
                color: #666666;
              }
              .val {
                flex: 1;
                text-align: left;
                font-size: 28px;
                color: #333333;
              }
            }
          }
          .down {
            display: flex;
            align-items: center;
            height: 78px;
            color: #666666;
            .label {
              width: 30%;
              font-size: 28px;
              color: #666666;
            }
            .val {
              flex: 1;
              text-align: left;
              font-size: 28px;
              color: #fba433;
            }
          }
        }
      }
    }
  }
}
</style>